const actions = {
  GET_USER_LOAD: 'GET_USER_LOAD',
  GET_USER_SUCCESS: 'GET_USER_SUCCESS',
  GET_USER_ERROR: 'GET_USER_ERROR',

  getLoad: () => {
    return { type: actions.GET_USER_LOAD };
  },
  getSuccess: (users) => {
    return { type: actions.GET_USER_SUCCESS, users };
  },
  getErr: (err) => {
    return { type: actions.GET_USER_ERROR, err };
  },

  ADD_USER_BEGIN: 'ADD_USER_BEGIN',
  ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
  ADD_USER_ERROR: 'ADD_USER_ERROR',

  addUserBegin: () => {
    return { type: actions.ADD_USER_BEGIN };
  },

  addUserSuccess: (users) => {
    return { type: actions.ADD_USER_SUCCESS, users };
  },

  addUserErr: (err) => {
    return { type: actions.ADD_USER_ERROR, err };
  },

  GET_USER_ROLE_BEGIN: 'GET_USER_ROLE_BEGIN',
  GET_USER_ROLE_SUCCESS: 'GET_USER_ROLE_SUCCESS',
  GET_USER_ROLE_ERROR: 'GET_USER_ROLE_ERROR',

  getRoleBegin: () => {
    return { type: actions.GET_USER_ROLE_BEGIN };
  },

  getRoleSuccess: (users) => {
    return { type: actions.GET_USER_ROLE_SUCCESS, users };
  },

  getRoleErr: (err) => {
    return { type: actions.GET_USER_ROLE_ERROR, err };
  },

  GET_USER_SINGLE__LOAD: 'GET_USER_SINGLE__LOAD',
  GET_USER_SINGLE__SUCCESS: 'GET_USER_SINGLE__SUCCESS',
  GET_USER_SINGLE__ERROR: 'GET_USER_SINGLE__ERROR',
  GET_USER_CLEAR_OBJECT: 'GET_USER_CLEAR_OBJECT',

  getSingleLoad: () => {
    return { type: actions.GET_USER_SINGLE__LOAD };
  },
  getSingleSuccess: (users) => {
    return { type: actions.GET_USER_SINGLE__SUCCESS, users };
  },
  getSingleErr: (err) => {
    return { type: actions.GET_USER_SINGLE__ERROR, err };
  },

  clearObject: () => {
    return { type: actions.GET_USER_CLEAR_OBJECT };
  },
};

export default actions;
